import type { ServiceContainer, ServiceProvider } from "../service-container";
import { BaseVirtualPixelDecoratorApplicator } from "./BaseVirtualPixelDecoratorApplicator";

/**
 * Pixel accessor service provider.
 * @internal
 */
export const pixelAccessorProvider: ServiceProvider = {
  /**
   * Registers entities, related to pixel accessor, in service container.
   * @param container
   */
  register(container: ServiceContainer) {
    container.register(
      "VirtualPixelDecoratorApplicator",
      new BaseVirtualPixelDecoratorApplicator()
    );
  },
};
